// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 文档类型枚举 枚举类
 * 文档类型枚举
 */
export enum EnumDocType {
  /** 元数据图形组件 : 元数据图形组件，代表通过图形设计器进行设计的元数据组件 */
  MDDiagramComponent = 1,
  /** 元数据页面组件 : 元数据页面组件，代表通过页面进行设计的元数据组件 */
  MDPageComponent = 2,
  /** 页面 : 页面 */
  WebPage = 4
}

/**
 * 文档类型枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumDocTypeMD {
  private static items = [
    new EnumItemMD('MDDiagramComponent', 1, '元数据图形组件', '元数据图形组件，代表通过图形设计器进行设计的元数据组件'),
    new EnumItemMD('MDPageComponent', 2, '元数据页面组件', '元数据页面组件，代表通过页面进行设计的元数据组件'),
    new EnumItemMD('WebPage', 4, '页面', '页面')
  ];

  static getItem(enumItem: EnumDocType) {
    return this.items.find(item => item.name === EnumDocType[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
